export const url_local = 'http://localhost:8000'
export const url_desarrollo = '/api'
export const url_produccion = 'https://portalcomunidadapi.esri.co'
export const bonda_login_url = process.env.REACT_APP_BONDA_LOGIN_URL || ''
// Muestra el botón "Ir a Canjear" salvo que REACT_APP_EXCHANGE_ENABLED sea false
export const exchange_enabled = !['false', '0', 'no', 'off'].includes(String(process.env.REACT_APP_EXCHANGE_ENABLED ?? '').trim().toLowerCase())
